export const MIXPANEL_HEADINGS={
    PREVENT_SCREEN_VIEWED:"KCC Care Pathway Screen 2 Viewed",
    TREAT_SCREEN_VIEWED:"KCC Care Pathway Screen 1 Viewed ",
    ACCOUNT_CREATION_SCREEN:"KCC Account Creation Screen Viewed",
    ACCOUNT_INFORMATION_SUBMITTED:"KCC Account Information Submitted",
    ELIGIBLITY_CHECKED:'"KCC Eligibility Checked',
    PROGRAM_ELIGIBLITY_SCREEN:'KCC Program Eligibility Screen Viewed'
}